module.exports = __webpack_public_path__ + "img/bg.2dd59833.jpg";